import { useNavigate, useLocation } from 'react-router-dom'
import React from 'react';
import redingToneImg from '../../../assets/svg/redington_word.png'
import { reactLocalStorage } from 'reactjs-localstorage';
import { checkEmployeeTeamType } from '../../../pages/employee/helper';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { DataStore } from 'aws-amplify';


export default function LeftSideBar() {
    const isMicrosoftAuthenticated = useIsAuthenticated();
    let isReportingManager = reactLocalStorage.get('isReportingManager')
    const navigateTo = useNavigate()
    const { instance } = useMsal();

    //Active Class Name
    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");

    async function logOut() {

        if (isMicrosoftAuthenticated === true) {
            reactLocalStorage.clear();
            navigateTo('/employee');
            instance.logout();
        }
        else {
            reactLocalStorage.clear();
            navigateTo('/employee');
            navigateTo(0);
        }
        await DataStore.clear();
    }

    return (
        // < !--Sidebar -- >
        <div>
            <div className="area"></div>

            <div className="flex flex-shrink-0 transition-all fixed left-wrapper z-10" id="main_menu ">
                {/* <!-- Left mini bar --> */}
                <nav aria-label="Options" className="z-20  py-0 h-screen top-0 h-screen bg-[#fff] dark:bg-[#2D2B29] sm:flex" id="menu_nav">
                    <div className="main-menu shadow-lg">
                        {/* <!-- Menu button --> */}
                        <ul>
                            <li className="mb-3"><button
                                type="button"
                                onClick={() => navigateTo('/employee/landing')}
                                className="focus:outline-none  menu">
                                <i className="icon home_icon "></i>
                                <span className="nav-text">
                                    Home
                                </span>
                            </button>
                            </li>

                            <li className={splitLocation[2] === "dashboard" ? "mb-3 active" : "mb-3"}><button
                                type="button"
                                onClick={() => {
                                    if (isReportingManager === "0") {
                                        navigateTo('/employee/dashboard/business')
                                    } else {
                                        !checkEmployeeTeamType() ? navigateTo('/employee/dashboard/sales/planning') : navigateTo('/employee/dashboard/business/planning')
                                    }
                                }}
                                className="focus:outline-none menu">
                                <i className="icon dashboard_icon "></i>
                                <span className="nav-text">
                                    Dashboard
                                </span>
                            </button>
                            </li>

                            <li className={splitLocation[2] === "planning" ? "mb-3 active" : "mb-3"}><button
                                type="button"
                                onClick={() => {
                                    if (isReportingManager === "0") {
                                        navigateTo("/employee/planning/self/manageplan")
                                    } else {
                                        navigateTo('/employee/planning/team/managetarget')
                                    }
                                }}
                                className="focus:outline-none  menu">
                                <i className="icon planing_icon "></i>
                                <span className="nav-text">
                                    Goals Setting
                                </span>
                            </button>
                            </li>
                            <li className={splitLocation[2] === "evaluation" ? "mb-3 active" : "mb-3"}><button
                                type="button"
                                onClick={() => {
                                    if (isReportingManager === "0") {
                                        navigateTo("/employee/evaluation/self/currentyear")
                                    } else {
                                        navigateTo('/employee/evaluation/team/currentyear')
                                    }
                                }}
                                className="focus:outline-none menu">
                                <i className="icon task_square "></i>
                                <span className="nav-text">
                                    Goals Evaluation
                                </span>
                            </button>
                            </li>
                            <li className="mb-3"><button
                                type="button" onClick={() => {
                                    if (isReportingManager === "0") {
                                        navigateTo("/employee/myself/changerequest")
                                    } else {
                                        navigateTo("/employee/myteam/changerequest")
                                    }
                                }}
                                className="focus:outline-none menu">
                                <i className="icon change_request_icon"></i>
                                <span className="nav-text">
                                    Change Request
                                </span>
                            </button>
                            </li>
                            <li className={splitLocation[2] === "message" ? "mb-3 active" : "mb-3"}><button
                                type="button" onClick={() => navigateTo('/employee/message')}
                                className="focus:outline-none menu">
                                <i className="icon comment_icon"></i>
                                <span className="nav-text">
                                    Messaging
                                </span>
                            </button>
                            </li>
                            <li className={splitLocation[2] === "reports" ? "mb-3 active" : "mb-3"}><button
                                type="button"
                                onClick={() => navigateTo('/employee/reports')}
                                className="focus:outline-none menu">
                                <i className="icon reports_icon"></i>
                                <span className="nav-text">
                                    Reports
                                </span>
                            </button>
                            </li>

                        </ul>
                        <ul className="logout">
                            {/* <li className={splitLocation[2] === "settings" ? "mb-3 active" : "mb-3"}>
                                <button onClick={() => {
                                    localStorage.setItem('selectedTab', 1)
                                    navigateTo('/employee/settings')
                                }} className="menu">
                                    <i className="icon support_icon"></i>
                                    <span className="nav-text">
                                        Settings
                                    </span>
                                </button>
                            </li> */}
                            <li className="mb-3">
                                <button
                                    onClick={logOut}
                                    className="menu">
                                    <i className="icon logout_icon"></i>
                                    <span className="nav-text">
                                        Logout
                                    </span>
                                </button>
                            </li>
                            <li>
                                <div className="menu">
                                    <i className="icon small_logo"></i>
                                    <span className="nav-text">
                                        <img className="" src={redingToneImg} alt="" />
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                {/* <CustomizeFormPopup
                isOpen={customizeFormModal}
                onRequestClose={() => setCustomizeFormModal(!customizeFormModal)}
            /> */}
            </div>
        </div>
    )
}